// extracted by mini-css-extract-plugin
export default {"storyDetailHeader":"c-r_hp"};